/* eslint-disable */
export default {
  sureToDeleteVoiceMail: 'Voulez-vous vraiment supprimer ce message vocal ?',
  sureToDeleteFax: 'Êtes-vous sûr de vouloir supprimer ce fax ?',
  doNotAskAgain: 'Ne plus afficher ce message à l’avenir',
} as const;

// @key: @#@"sureToDeleteVoiceMail"@#@ @source: @#@"Are you sure you want to delete this voicemail?"@#@
// @key: @#@"sureToDeleteFax"@#@ @source: @#@"Are you sure you want to delete this fax?"@#@
// @key: @#@"doNotAskAgain"@#@ @source: @#@"Don't ask me again"@#@
